<template>
  <modal
    name="upgrade-failed"
    :click-to-close="false"
    height="auto"
    :adaptive="true"
    :scrollable="true"
    width="75%"
    :max-width="900"
    :pivot-y="0.2"
  >
    <Error
      v-if="!$apollo.loading && errors.length"
      message="It looks like we couldn't check your send eligibility right now. Please refresh and try again."
      :errors="errors"
      class="mb-8 md:mb-10 md:mt-2 max-w-md mx-auto"
    />

    <div v-if="$apollo.loading" class="content">
      <Loader label="Loading..." />
    </div>

    <Button v-if="!$apollo.loading" class="close-button" @click="onCloseClick">
      <v-icon slot="icon-end" name="times" />
    </Button>

    <div v-if="!$apollo.loading" class="text-center">
      <div class="content">
        <div class="icon-wrap">
          <v-icon name="rocket" scale="2.5" class="send-icon v-center" />
        </div>

        <h1 class="text-center text-lg sm:text-2xl mb-8">
          Upgrade Failed
        </h1>

        <p class="mb-0 max-w-xs mx-auto text-sm">
          Sorry but it looks like the charge to upgrade your account failed. If
          you continue to have problems, please contact us so our team can
          investigate.
        </p>
      </div>
      <div v-if="hasUpgradeUrl" class="action-panel items-center">
        <Button
          class="secondary mx-auto"
          :loading="upgrading"
          @click="onUpgradeClick"
        >
          {{ upgrading ? "Loading..." : "Try again?" }}
          <v-icon
            slot="icon-end"
            name="shopify"
            class="shopify-icon"
            scale="1.1"
          />
        </Button>
      </div>
    </div>
  </modal>
</template>

<script>
import Error from "@/components/UI/Error";
import Loader from "@/components/UI/Loader";
import { SendCampaignCheck } from "@/graphql/queries";
import { isAuthError } from "@/lib/auth";

export default {
  apollo: {
    sendCampaignCheck: {
      query: () => SendCampaignCheck,
      variables: function() {
        return {
          input: { campaignId: this.$route.params.id },
        };
      },
      error({ graphQLErrors }) {
        if (graphQLErrors.length) {
          // If we have an auth error return false here as the login modal should open...
          if (isAuthError(graphQLErrors)) return false;

          this.errors = graphQLErrors.map(({ message }) => message);
        }
      },
    },
  },
  name: "UpgradeFailedModal",
  components: { Loader, Error },
  data() {
    return {
      errors: [],
      upgrading: false,
    };
  },
  computed: {
    hasUpgradeUrl() {
      return this.$has(this.sendCampaignCheck, "check.upgradeUrl");
    },
  },
  methods: {
    onCloseClick() {
      this.$modal.hide("upgrade-failed");
      // Remove the upgrade failed message from the query string so the user doesn't see it again upon refresh
      this.$router.replace(`/campaign/${this.$route.params.id}`);
    },
    onUpgradeClick() {
      this.upgrading = true;

      window.document.location.href = this.sendCampaignCheck.check.upgradeUrl;
    },
  },
};
</script>

<style scoped>
>>> .v--modal {
  padding: 0;
}

.content {
  @apply p-2;

  @screen md {
    @apply p-8;
  }
}

.shopify-icon {
  @apply relative;
  top: 2px;
}

.send-icon {
  @apply text-brand;
}

.action-panel {
  @apply flex flex-wrap w-full border-grey-lighter border-t bg-grey-lightest p-4 relative;

  button {
    @apply p-1;
  }

  @screen md {
    @apply p-8;

    button {
      @apply py-2 px-4;
    }
  }
}
</style>
